import React from "react";

import { PRICE_PER_CREDIT } from "utils/payment/constants";
import { convertToDollars } from "utils/payment/helpers";

import Button from "components/Button";
import Divider from "components/Divider";
import Loading from "components/Loading";

import classes from "./styles.module.scss";

const TaxSpinner = () => <Loading className={classes.taxSpinner} subClassName={classes.taxSpinnerInner} />;

const Footer = ({ goNext, currentStep, amountToPurchase = 0, paymentStatus = "step_1", taxInfo = null }) => {
    const subtotalCents = amountToPurchase * PRICE_PER_CREDIT;
    const subtotalInDollars = convertToDollars(subtotalCents);

    // Tax is unknown until the buyer enters their billing address on Step 2, where Stripe
    // Tax prices it from the postal code. Until then we show a placeholder rather than a
    // hardcoded estimate.
    const taxReady = taxInfo?.status === "ready";
    const taxLoading = taxInfo?.status === "loading" || paymentStatus === "pricing";

    const pendingDisplay = taxLoading ? <TaxSpinner /> : "Calculated at checkout";

    const taxDisplay = taxReady ? `$${convertToDollars(taxInfo.taxAmount)}` : pendingDisplay;
    const totalDisplay = taxReady ? `$${convertToDollars(taxInfo.amountTotal)}` : pendingDisplay;

    let buttonLabel = "";
    if (paymentStatus === "pricing") {
        buttonLabel = "Calculating tax...";
    } else if (paymentStatus === "processing") {
        buttonLabel = "Processing payment...";
    } else if (paymentStatus === "preparing") {
        buttonLabel = "Preparing payment...";
    } else if (paymentStatus === "success") {
        buttonLabel = "Payment successful";
    } else if (currentStep === "step_1") {
        buttonLabel = "Next";
    } else if (taxReady) {
        // Tax priced from the card's postal code — this tap charges
        buttonLabel = `Pay $${convertToDollars(taxInfo.amountTotal)}`;
    } else {
        // Waiting on complete card details before we can price tax
        buttonLabel = "Enter card details";
    }

    // On Step 2, the button only charges once tax is priced (which happens automatically
    // as soon as the card form — including Stripe's postal field — is complete).
    const taxBlocksPayment = currentStep === "step_2" && !taxReady;

    return (
        <div className={classes.paymentFooterContainer}>
            <div className={classes.subTotalContainer}>
                <div className={classes.amountRow}>
                    <span className={classes.leftSpan}>Subtotal:</span>
                    <span>${subtotalInDollars}</span>
                </div>
                <div className={classes.amountRow}>
                    <span className={classes.leftSpan}>Tax</span>
                    <span>{taxDisplay}</span>
                </div>
            </div>
            <Divider />
            <div>
                <div className={classes.amountRow}>
                    <span className={classes.leftSpan}>Total:</span>
                    <span>{totalDisplay}</span>
                </div>
            </div>
            <Button
                onClick={goNext}
                disabled={
                    paymentStatus === "pricing" ||
                    paymentStatus === "processing" ||
                    paymentStatus === "success" ||
                    paymentStatus === "preparing" ||
                    taxBlocksPayment
                }
            >
                {buttonLabel}
            </Button>
        </div>
    );
};

export default Footer;
